import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownProps {
  title?: string;
  className?: string;
}
function Unit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex min-w-[68px] flex-col items-center sm:min-w-[82px]" data-id="element-27" data-mp="3l3c91mdunguw">
      <span className="flex h-[72px] w-[68px] items-center justify-center rounded-xl border border-white/10 bg-[#0B0B0D] font-display text-3xl font-bold tabular-nums text-white shadow-inner sm:h-20 sm:w-20 sm:text-4xl" data-id="element-28" data-mp="3q1dv8g6knwal">
        {value}
      </span>
      <span className="mt-3 text-[10px] font-semibold uppercase tracking-[0.08em] text-white/55 sm:text-xs" data-id="element-29" data-mp="3h2jz0qx5l7xk">
        {label}
      </span>
    </div>;
}
export function Countdown({
  title = 'EL PRECIO DE LANZAMIENTO TERMINA EN:',
  className = ''
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className={`mx-auto w-full max-w-xl rounded-2xl bg-[#211A1B] px-5 py-8 text-center shadow-[0_16px_36px_rgba(17,24,39,0.18)] ring-1 ring-bordo/15 sm:px-10 sm:py-9 ${className}`} data-id="element-30" data-mp="10aihtopj1t0g">
      <p className="text-xs font-extrabold uppercase tracking-[0.1em] text-red-400 sm:text-base" data-id="element-31" data-mp="xytxihdjl369">{title}</p>
      <div className="mt-6 flex items-start justify-center gap-2 sm:gap-4" role="timer" aria-live="off" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-32" data-mp="17qzts3atu6r9">
        <Unit value={hours} label="Horas" data-id="element-33" data-mp="f1iwosc9i1op" />
        <span className="mt-5 font-display text-3xl font-bold text-red-400" aria-hidden="true" data-id="element-34" data-mp="f2kgpmb99yik">:</span>
        <Unit value={minutes} label="Min" data-id="element-35" data-mp="a5c0hr9o44jy" />
        <span className="mt-5 font-display text-3xl font-bold text-red-400" aria-hidden="true" data-id="element-36" data-mp="o3ifnq6u7fua">:</span>
        <Unit value={seconds} label="Seg" data-id="element-37" data-mp="k15ktwtmp2ca" />
      </div>
    </div>;
}